/**
 * AUTH
 */
export const authActionTypes = {
  AUTH_START: "AUTH_START",
  AUTH_START_WITH_STORED_TOKEN: "AUTH_START_WITH_STORED_TOKEN",
  AUTH_START_WITH_TOKEN_FROM_REDIRECTION:
    "AUTH_START_WITH_TOKEN_FROM_REDIRECTION",
  REFRESH_ACCESS_TOKEN_START: "REFRESH_ACCESS_TOKEN_START",
  SET_USER: "SET_USER",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_ERROR: "AUTH_ERROR",
  AUTH_LOGOUT_START: "AUTH_LOGOUT_START",
};
